module.exports = __webpack_public_path__ + "img/4.92cd7143.jpg";